import { render, staticRenderFns } from "./HsabExpenseFormAddBankAccount.vue?vue&type=template&id=fb3a831e&scoped=true"
import script from "./HsabExpenseFormAddBankAccount.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseFormAddBankAccount.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseFormAddBankAccount.vue?vue&type=style&index=0&id=fb3a831e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3a831e",
  null
  
)

export default component.exports